import { api } from './client'

export interface FuelPrice {
  id: number
  fuel_type: string
  price_per_liter: number | string
  effective_date: string
  is_active: boolean
  notes?: string
  created_at?: string
  updated_at?: string
}

export interface FuelPriceCreate {
  fuel_type: string
  price_per_liter: number
  effective_date: string
  is_active?: boolean
  notes?: string
}

export const fuelPriceApi = {
  async getAll(): Promise<FuelPrice[]> {
    const resp = await api.get('/fuel/prices/')
    const data = resp.data
    if (Array.isArray(data)) return data as FuelPrice[]
    if (data && typeof data === 'object') {
      const obj = data as Record<string, unknown>
      if (Array.isArray(obj.results)) return obj.results as FuelPrice[]
      if (Array.isArray(obj.data)) return obj.data as FuelPrice[]
    }
    return []
  },

  async getCurrent(fuelType?: string): Promise<{ fuel_type: string; price_per_liter: number; effective_date: string | null }> {
    const params = fuelType ? { fuel_type: fuelType } : {}
    const resp = await api.get('/fuel/prices/current/', { params })
    return resp.data
  },

  async create(data: FuelPriceCreate): Promise<FuelPrice> {
    const resp = await api.post('/fuel/prices/', data)
    return resp.data
  },

  async update(id: number, data: Partial<FuelPriceCreate>): Promise<FuelPrice> {
    const resp = await api.patch(`/fuel/prices/${id}/`, data)
    return resp.data
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/fuel/prices/${id}/`)
  }
}
